import React from 'react';
import { Card } from 'react-bootstrap';
import './bloodwork-anemia-status.css';
import { LabsmartsGuage } from '../charts/LabsmartsGauge';
import { BloodworkAnalysis } from '../../models/BloodworkAnalysis';

type Props = {
  bloodworkAnalysis: BloodworkAnalysis;
};

export class AnemiaStatus extends React.Component<Props, {}> {
  
  possibleRootCauses = (bloodworkAnalysis: BloodworkAnalysis) => {
    const possibleRootCauses = bloodworkAnalysis.possibleRootCauses();
    if (possibleRootCauses.length) {
      return (
        <div className="possible-root-causes-container">
          <div className="possible-root-causes-title">Possible Root Causes</div>
          <ul className="possible-root-causes">
          {
            bloodworkAnalysis.possibleRootCauses().map((cause, index) => {
              return <li className="possible-root-cause" key={index}>{cause}</li>;
            })
          }
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { bloodworkAnalysis } = this.props;
    if (!bloodworkAnalysis.bloodwork) {
      return null;
    }

    console.log(bloodworkAnalysis.redBloodCellSize);
    console.log(bloodworkAnalysis.redBloodCellColor);

    return (
        <Card className="evaluationPanel" id="rbc-evaluation">
            <Card.Header className="evaluationPanelHeading">
              RBC Insights
            </Card.Header>
            <Card.Body>
              <div className="anemiaStatusContainer">
                <LabsmartsGuage
                  text="Suboptimal Blood Oxygen Delivery is"
                  chartContainerId="anemiaStatusGuage"
                  bloodwork={bloodworkAnalysis.bloodwork}
                  category={bloodworkAnalysis.anemicProbabilityCategory}
                  probability={bloodworkAnalysis.anemicProbability}
                />
                <div className="colorSize">
                  <div className="rbcSizeColor rbcSize">
                    <div className="statusTitle">RBC Size</div>
                    <div className="statusType">{bloodworkAnalysis.redBloodCellSize.type}</div>
                    <div className="statusName">({bloodworkAnalysis.redBloodCellSize.name})</div>
                  </div>
                  <div className="rbcSizeColor rbcColor">
                    <div className="statusTitle">RBC Color</div>
                    <div className="statusType">{bloodworkAnalysis.redBloodCellColor.type}</div>
                    <div className="statusName">({bloodworkAnalysis.redBloodCellColor.name})</div>
                  </div>
                  <div className="clearfix" /> 
                </div>
                {
                  bloodworkAnalysis.nutrientDeficiencyOrInflammationLikelyText ? 
                    <div className="nutrient-deficiency-or-inflammation-likely">
                      {bloodworkAnalysis.nutrientDeficiencyOrInflammationLikelyText}
                    </div> 
                  : null
                }
                {
                  bloodworkAnalysis.boneMarrowAnalysis.boneMarrowOverproductionIsLikely ?
                    <div className="condition-section">
                      Bone Marrow Overproduction is Likely
                    </div>
                  : null
                }
                {this.possibleRootCauses(bloodworkAnalysis)}
                {
                  bloodworkAnalysis.isAnyDehydrationPossibleOrHigher() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.deriveDehydrationText()}
                    </div>
                  : null
                }
                {
                  bloodworkAnalysis.isPoorOxygenationPossibleOrHigher() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.derivePoorOxygenationText()}
                    </div>
                  : null
                }
                {
                  bloodworkAnalysis.isPoorOxygenationDueToSmoking() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.derivePoorOxygenationTextForSmoker()}
                    </div>
                  : null
                }
              </div>
            </Card.Body>
        </Card>
    );
  }
}
